<template>
  <v-list-item
    @click="e => menuItemClick(item.to, e)"
    @click.middle.exact="e => menuItemClick(item.to, e, true)"
    exact-path
    :class="{
      'bg-gradient-primary v-list-item--active white--text': isActive,
    }"
    class="vertical-nav-menu-link"
    active-class="bg-gradient-primary">
    <v-list-item-icon>
      <component class="vertical-nav-menu__custom-icon" v-if="isVue(item.icon)" :is="item.icon"></component>
      <v-icon
        v-else
        :class="{
          'alternate-icon-small': !item.icon,
        }">
        {{ item.icon || alternateIcon }}
      </v-icon>
    </v-list-item-icon>

    <v-list-item-title
      :class="{
        'white--text': isActive,
      }">
      {{ t(item.title) }}
    </v-list-item-title>
    <v-list-item-action v-if="item.badge" class="flex-shrink-0">
      <v-badge :color="item.badgeColor" inline :content="item.badge"> </v-badge>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
  import useVerticalNavLink from "@core/layouts/composable/vertical-nav/useVerticalNavLink";
  import { useUtils } from "@core/libs/i18n";
  import themeConfig from "@themeConfig";
  import { useRouter } from "@core/utils";
  import { eventBus } from "@/event-bus";

  export default {
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    setup(props) {
      const { isActive, linkProps } = useVerticalNavLink(props.item);
      const { t } = useUtils();

      // If parameter value is an object, it means it is a vue component instance. Otherwise it's an mdi icon
      const isVue = obj => {
        if (typeof obj === "string") return false;

        return true;
      };
      const { route, router } = useRouter();
      const menuItemClick = (routeName, e, middleClick) => {
        if (routeName.includes("http")) {
          window.open(routeName, "_blank");

          return;
        }

        if (e?.ctrlKey || e?.metaKey || middleClick) {
          window.open(router.resolve({ name: routeName }).href, "_blank");

          return;
        }

        if (route.value.meta.disableRedirect) {
          eventBus.$emit("open-exit-modal", routeName);
        } else {
          router.push({ name: routeName }).catch(err => {
            if (err.name !== "NavigationDuplicated") {
              throw err;
            }
          });
        }
      };

      return {
        menuItemClick,
        isVue,
        isActive,
        linkProps,
        alternateIcon: themeConfig.menu.groupChildIcon,

        // i18n
        t,
      };
    },
  };
</script>

<style lang="scss">
  @import "~vuetify/src/styles/styles.sass";
  @import "../../../../../preset/preset/typography/index";
  @import "../../../../../preset/preset/functions";

  .vertical-nav-menu-link {
    .vertical-nav-menu__custom-icon {
      path {
        fill: get-color("same-menu-text") !important;
      }
    }
    &:hover {
      .vertical-nav-menu__custom-icon {
        path {
          fill: get-color("same-white") !important;
        }
      }
    }
    .v-list-item__icon {
      .v-icon {
        color: get-color("same-menu-text") !important;
      }
    }

    .v-list-item__title {
      color: get-color("same-menu-text") !important;
      @include text-body-1();
    }

    &:hover {
      .v-list-item__icon {
        .v-icon {
          color: get-color("same-white") !important;
        }
      }

      .v-list-item__title {
        color: get-color("same-white") !important;
      }
    }
  }

  .vertical-nav-menu-link {
    &.v-list-item--active {
      .v-list-item__icon {
        .v-icon {
          color: get-color("same-white") !important;
        }
      }

      .vertical-nav-menu__custom-icon {
        path {
          fill: get-color("same-white") !important;
        }
      }

      .v-list-item__title.white--text {
        z-index: 1;
        color: get-color("same-white") !important;
      }
    }
  }
</style>
